import { FailureItem } from '../../../../../common/components/ItemsSummaryModal/ItemsSummaryModal';
import { Language } from '../../../../../contexts/LocalizationContext/types';

export type TranslateFn = (key: string) => string;

/**
 * Builds and downloads a CSV file for the provided not-assigned items (errors) list.
 * - Escapes values for CSV (quotes doubled, wrapped in quotes)
 * - Prepends UTF-8 BOM for Excel compatibility
 * - Uses current UI translations for headers
 */
export const downloadNotAssignedItemsCsv = (params: {
  items: FailureItem[];
  language: Language;
  translations: TranslateFn;
}): void => {
  const { items, language, translations } = params;
  if (!items?.length) return;

  const headers = [
    translations('item_category'),
    translations('item_name'),
    translations('relevo_uid'),
    translations('error'),
  ];

  const escape = (val: unknown) => `"${String(val ?? '').replace(/"/g, '""')}"`;

  const rows = items.map((it) => [
    it.product?.category.translations[language] ?? '',
    it.product?.productName ?? '',
    it.product?.uId ?? '',
    it.message ?? '',
  ]);

  const csv = [headers, ...rows].map((row) => row.map(escape).join(',')).join('\r\n');

  const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const ts = new Date().toISOString().replace(/[:T]/g, '-').split('.')[0];
  link.href = url;
  link.download = `relevo-error-list-${ts}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
